import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import * as yup from 'yup';

import { FormikDialogForm } from '../../../components/formikDialogForm/components/FormikDialogForm';
import { DialogMode } from '../../../components/formikDialogForm/types';
import { FormikTextField } from '../../../components/formikInputs/FormikTextField';
import { useCreateKundeMutation, useUpdateKundeMutation } from '../api/kundeApi';
import { CreateKundeDTO, KontaktTyp, Kunde, UpdateKundeDTO } from '../api/types';

export const createKundeDTO: CreateKundeDTO = {
  typ: KontaktTyp.KUNDE,
  organisation: '',
  email: null,
  telefonnummer: null,
  quelle: null,
  vertriebsStatus: null,
  angebotsnummer: null,
  angebotslink: null,
  bemerkung: null,
  zuletztBearbeitet: null,
  stadt: null,
  postleitzahl: null,
  strasse: null,
  hausnummer: null,
  adresszusatz: null,
  operativerAnsprechpartner: null,
};

export const kundeValidationSchema = yup.object({
  organisation: yup.string().required('erforderlich'),
  stadt: yup.string().nullable().notRequired(),
  postleitzahl: yup.string().nullable().notRequired(),
  strasse: yup.string().nullable().notRequired(),
  hausnummer: yup.string().nullable().notRequired(),
  adresszusatz: yup.string().nullable().notRequired(),
  operativerAnsprechpartner: yup.string().nullable().notRequired(),
});

export const KundeDialogForm: FC = () => {
  const [createKunde, { isLoading: createKundeLoading }] = useCreateKundeMutation();
  const [updateKunde, { isLoading: updateKundeLoading }] = useUpdateKundeMutation();

  const loading = createKundeLoading || updateKundeLoading;

  const saveKunde = (dto: CreateKundeDTO | UpdateKundeDTO, mode: DialogMode): Promise<Kunde> => {
    let savePromise;
    if (mode === 'create') {
      savePromise = createKunde(dto as CreateKundeDTO);
    } else {
      savePromise = updateKunde(dto as UpdateKundeDTO);
    }
    return savePromise.unwrap();
  };

  return (
    <FormikDialogForm
      dialogId={'kunde'}
      title={mode => (mode === 'create' ? 'Neuer Kunde' : 'Kunde bearbeiten')}
      onSubmit={saveKunde}
      creationInitialValues={createKundeDTO}
      validationSchema={kundeValidationSchema}
      loading={loading}
      form={
        <div>
          <Typography sx={{ mb: 2 }}>Stammdaten</Typography>
          <Grid container spacing={2}>
            <Grid size={6}>
              <FormikTextField
                name="organisation"
                textFieldProps={{ label: 'Organisation', fullWidth: true, required: true }}
              />
            </Grid>
            <Grid size={6}>
              <FormikTextField
                name="operativerAnsprechpartner"
                textFieldProps={{ label: 'Operativer Ansprechpartner', fullWidth: true }}
              />
            </Grid>
            <Grid size={6}>
              <FormikTextField
                name="strasse"
                textFieldProps={{ label: 'Straße', fullWidth: true }}
              />
            </Grid>
            <Grid size={3}>
              <FormikTextField
                name="hausnummer"
                textFieldProps={{ label: 'Hausnummer', fullWidth: true }}
              />
            </Grid>
            <Grid size={3}>
              <FormikTextField
                name="adresszusatz"
                textFieldProps={{ label: 'Adresszusatz', fullWidth: true }}
              />
            </Grid>
            <Grid size={6}>
              <FormikTextField
                name="postleitzahl"
                textFieldProps={{ label: 'PLZ', fullWidth: true }}
              />
            </Grid>
            <Grid size={6}>
              <FormikTextField name="stadt" textFieldProps={{ label: 'Stadt', fullWidth: true }} />
            </Grid>
          </Grid>
        </div>
      }
    />
  );
};
